<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
  <div class="card">
    <div class="card-header">
      {{ words[language][ 'businessContact' ] }}
      <button (click)="reset()" title="Add" type="button" class="btn btn-sm btn-primary float-right" data-toggle="modal" data-target="#businessContacts" [disabled]="contactId == 0">Add</button>
    </div>
    <div class="card-body">
      @if (businessContactList.length>0) {
        <table class="table table-sm table-hover table-striped table-responsive">
          <thead>
            <tr>
              @for (header of headers; track header) {
                <th>{{ words[language][ header.name ] }}
                </th>
              }
            </tr>
          </thead>
          <tbody class="text-dark">
            @for (businessContact of businessContactList; track businessContact) {
              <tr class="text-dark">
                <td>{{businessContact.title}}</td>
                <td>{{businessContact.contact.firstName}}</td>
                <td>{{businessContact.contact.lastName}}</td>
                <td>@for (phone of filterForCommunication(businessContact,'phone'); track phone) {
                  <span
                  >{{phone.value}}</span>
                }
              </td>
              <td>@for (email of filterForCommunication(businessContact,'email'); track email) {
                <span
                >{{email.value}}</span>
              }
            </td>
            <!-- actions -->
            <td class="table-action">
              <button class="btn btn-sm btn-outline-dark text-dark"
                (click)="getContactBusinessContactDetail(businessContact,true)"
              id="contactbusinessContactDetail">Edit Contact</button>
              <button data-toggle="modal" title="Delete" data-target="#deleteModalBusinessContacts"
                (click)="setBusinessContact(businessContact, 'delete')"
              class="btn btn-sm btn-outline-danger text-danger ml-1">Delete</button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
</div>
<div class="text-right">
  <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
  <!-- <button class="btn btn-sm btn-success" (click)="reactivateRole()">Reactivate Role</button> -->
</div>
</div>

<!-- modals -->
<div id="businessContacts" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'addNewbusinessContact' ] }}</h4>
        <button type="button" class="close" data-dismiss="modal">×</button>
      </div>
      <div class="modal-body">
        <form [formGroup]="information" class="row">
          <div class="form-group col-md-4 col-sm-12 my-1">
            <label for="firstName">{{ words[language][ 'firstName' ] }}</label>
            <div class="position-relative hover-list">
              <input class="form-control" type="search" id="firstName" formControlName="firstName"
                autocomplete="off" list="contact-list" autofocus="true" [readonly]="isContactSelected">
            </div>
            @if (firstName.invalid && firstName.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidFirstName' ] }}</span>
            }
          </div>
          <div class="form-group col-md-4 col-sm-12 my-1">
            <label for="lastName">{{ words[language][ 'lastName' ] }} </label>
            <input class="form-control" type="text" id="lastName" formControlName="lastName"
              [readonly]="isContactSelected">
            @if (lastName.invalid && lastName.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidLastName' ] }}</span>
            }
          </div>
          <div class="form-group col-md-4 col-sm-12 my-1">
            <label for="title">{{ words[language][ 'title' ] }} </label>
            <input class="form-control" type="text" id="title" formControlName="title">
          </div>
          <div class="form-group col-md-4 col-sm-12 my-1">
            <label for="phoneNumber">{{ words[language][ 'phoneNumber' ] }}</label>
            <input class="form-control" type="tel" id="phoneNumber" formControlName="phoneNumber">
            @if (phoneNumber.invalid && phoneNumber.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidPhoneNumber' ] }}</span>
            }
          </div>
          <div class="form-group col-md-4 col-sm-12 my-1">
            <label for="emailAddress">{{ words[language][ 'emailAddress' ] }}</label>
            <input class="form-control" type="text" id="emailAddress" formControlName="emailAddress">
            @if (emailAddress.invalid && emailAddress.dirty) {
              <span class="text-danger">{{
              words[language][ 'invalidEmailAddress' ] }}</span>
            }
          </div>
        </form>
        <div class="modal-footer">
          <button class="btn btn-success mr-2" id="btn-save-contact-businessContact"
            (click)="createContact(true)" [disabled]="information.invalid || loading">
            @if (loading) {
              <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
            }
          Save</button>
          <button class="btn btn-light" data-dismiss="modal" id="btn-cancel-businessContacts-new">{{
          words[language][ 'cancel' ] }}</button>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- ! delete modal -->
<div class="modal fade" id="deleteModalBusinessContacts" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="uil-trash-alt text-danger h1"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deleteBusinessContact' ] }}</span>

        <button class="btn btn-danger mt-2" (click)="discard()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
          {{ words[language][ 'continue' ] }}
        </button>
        <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
          id="close-delete-modal-businessContact">{{ words[language][ 'cancel' ]
        }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

@if (viewDetail) {
  <contact-modal [contactId]="auxContact.id" [language]="language" [words]="words" (modified)="modified($event)"></contact-modal>
}
